import * as React from "react";
import { Component } from "react";
import { connect } from "react-redux";

import ChemistOrder from "../../screens/Chemist/ChemistOrder";

import { fetchChemistOrders, pageSelected, ChemistOrdersview, itempageSelected } from "./action";

class ChemistOrderContainer extends Component {
  render() {
    return (
      <ChemistOrder
        fetchChemistOrders={this.props.fetchChemistOrders}
        chemistOrderDetails={this.props.chemistOrderDetails}
        chemistOrdersCount={this.props.chemistOrdersCount}
        pageSelected={this.props.pageSelected}
        ChemistOrdersview={this.props.ChemistOrdersview}
        chemistOrderDtls={this.props.chemistOrderDtls}
        chemistOrderDtlsCount={this.props.chemistOrderDtlsCount}
        itempageSelected={this.props.itempageSelected}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    fetchChemistOrders: value => {
      dispatch(fetchChemistOrders(value));
    },
    pageSelected: value => {
      dispatch(pageSelected(value));
    },
    ChemistOrdersview: value => {
      dispatch(ChemistOrdersview(value));
    },
    itempageSelected:(value) => {
      dispatch(itempageSelected(value));
    },
  };
}

const mapStateToProps = state => {
  return {
    chemistOrderDetails: state.ChemistOrderReducer.chemistOrderDetails,
    chemistOrdersCount: state.ChemistOrderReducer.chemistOrdersCount,
    chemistOrderDtls: state.ChemistOrderReducer.chemistOrderDtls,
    chemistOrderDtlsCount:state.ChemistOrderReducer.chemistOrderDtlsCount
  };
};

export default connect(
  mapStateToProps,
  bindAction
)(ChemistOrderContainer);
